/* COMPOUND rebrand - header search collapse/expand (clip reveal) */
(function(){
  function fixBanner(){
    document.querySelectorAll('.sliding-text').forEach(function(el){
      el.style.setProperty('background-color','#f8f8f8','important');
      el.style.setProperty('--color-background-rgb','248,248,248','important');
      el.style.setProperty('--color-foreground-rgb','114,114,114','important');
    });
  }
  function init(){
    fixBanner();
    var form=document.querySelector('#MainHeader .cmpd-inline-search'); if(!form) return;
    var input=form.querySelector('input[type="search"]'), btn=form.querySelector('.cmpd-inline-search__btn');
    if(!input||!btn) return;
    if(!input.closest('.cmpd-search-clip')){
      var clip=document.createElement('span'); clip.className='cmpd-search-clip';
      input.parentNode.insertBefore(clip, input); clip.appendChild(input);
    }
    form.classList.add('cmpd-search-ready');
    if(input.value.trim()!=='') form.classList.add('cmpd-open');
    btn.addEventListener('click', function(e){
      if(!form.classList.contains('cmpd-open')){ e.preventDefault(); form.classList.add('cmpd-open'); setTimeout(function(){input.focus();},80); }
      else if(input.value.trim()===''){ e.preventDefault(); form.classList.remove('cmpd-open'); input.blur(); }
    });
    document.addEventListener('click', function(e){ if(form.classList.contains('cmpd-open') && !form.contains(e.target) && input.value.trim()==='') form.classList.remove('cmpd-open'); });
    input.addEventListener('keydown', function(e){ if(e.key==='Escape'){ input.value=''; form.classList.remove('cmpd-open'); input.blur(); } });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
